
<div class="card">
    <div class="card-header">
        <h4>Add Commission Profile</h4>
    </div>
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'service'">Basic Information</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'commission'">Commission Setup</a>
            </li>
          </ul>
    </div>

    <div class="tab-content pt-2" id="myTabContent">
         <div id="service" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'service'? 'block' : 'none'}">
          <form #addCommissionprofile="ngForm" (ngSubmit)="saveCommissionProfile(addCommissionprofile.value)" [formGroup]="addCommissionProfileForm">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-4">
                          <label class="col-form-label" for="commissionProfileName">Commission Profile Name <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" autocomplete="off" id="commissionProfileName" class="form-control" required formControlName="commissionProfileName" (paste)="onPaste($event)"  (keypress)="OnlyCharacterAllowed($event)" placeholder="Enter Commission Profile Name" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.commissionProfileName.errors}"  name="commissionProfileName">
                          <div class="invalid-feedback">
                            Commission Profile Name is required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label class="col-form-label" for="commissionProfileDesc">Commission Profile Description <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" autocomplete="off" id="commissionProfileDesc" class="form-control" required formControlName="commissionProfileDesc" (paste)="onPaste($event)"  (keypress)="OnlyCharacterAllowed($event)" placeholder="Enter Commission Profile Description" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.commissionProfileDesc.errors}"  name="commissionProfileDesc">
                          <div class="invalid-feedback">
                            Commission Profile Description is required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="country">Country <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>                      
                            <ng-select id="country" [items]="countryDropDown" bindLabel="name" bindValue="id" placeholder="Select Country"  formControlName="country" name="country"  required (change)="countryChange($event)" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.country.errors}" >
                            </ng-select>   
                            <div class="invalid-feedback" >
                                <div>
                                    Country is required.
                                </div>
                            </div>
                        </div>
            
                      </div>
                      <div class="row d-flex">
                        
                          <div class="form-group col-md-4">
                              <label class="col-form-label" for="category">Category <span aria-hidden="true"
                                      class="symbol required" style="color:red;">*</span>
                              </label>
                              <ng-select [items]="categoryDropDown" placeholder="Select Category" bindLabel="name" (change)="categoryChange($event)" id="category" formControlName="category" required  [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.category.errors}"  name="category">
                              </ng-select>
                              
                              <div class="invalid-feedback" >
                                  <div >
                                    Category is required.
                                  </div>
                              </div>
                          </div>
                          <div class="form-group col-md-4">
                            <label class="col-form-label" for="subCategory">Sub Category <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <ng-select [items]="subCategoryDropDown" placeholder="Select Subcategory" bindLabel="name" (change)="subCategoryChange($event)" id="subCategory" formControlName="subCategory" required  [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.subCategory.errors}"  name="subCategory">
                            </ng-select>
                            <div class="invalid-feedback" >
                                <div >
                                  Sub Category is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="product">Product <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <ng-select [items]="productDropDown" placeholder="Select Product" bindLabel="name" bindValue="id" id="product" formControlName="product" required (change)="productChange($event)" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.product.errors}"  name="product">

                              </ng-select>
                            <div class="invalid-feedback" >
                                <div >
                                    Product is required.
                                </div>
                            </div>
                        </div>
                    </div>

                        <div class="row d-flex" >
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="serviceProvider">Service Provider <span aria-hidden="true"
                                        class="symbol required" style="color:red;">*</span>
                                </label>
                                <ng-select [items]="serviceProviderDropDown" placeholder="Select Service Provider" bindLabel="name" bindValue="id" id="product" formControlName="serviceProvider" required (change)="serviceProviderChange($event)" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.serviceProvider.errors}"  name="serviceProvider">
    
                                  </ng-select>
                                <div class="invalid-feedback" >
                                    <div >
                                        Service Provider is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="maxBalance">Maximum Balance <span aria-hidden="true"
                                        class="symbol required" style="color:red;">*</span>
                                </label>
                                <input type="text" id="maxBalance" readonly maxlength="8" class="form-control" required formControlName="maxBalance" placeholder="Maximum Balance" [ngClass]="{'is-invalid':submitted && addCommissionProfileForm.controls.maxBalance.errors}">
                                <div class="invalid-feedback">
                                    Maximum Balance is required
                                  </div>
                              </div>
                        </div>    
                    <br>
                      <div class="row">
                          <div class="form-group col-md-12 text-right">
                              <button type="submit" class="btn btn-primary">Save & Next</button>
                              <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </form>
         </div>
         <div id="commission" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Product Name</label>
                            <input type="text" id="productName" readonly value="{{productName}}" class="form-control">
                        </div>
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Country</label>
                            <input type="text" id="category" readonly value="{{countryName}}" class="form-control">
                        </div>
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Service Provider</label> 
                            <input type="text"  id="subCategory" readonly value="{{serviceProviderName}}" class="form-control">
                        </div>
                        <div class="form-group col-md-1"></div>
                        <div class="form-group col-md-2 " style="margin-top: 40px;">
                            <button type="button" class="btn btn-primary" (click)="addNewSet()" >New Slab</button>
                        </div>
                          
                      </div>
                      <br>
                      <div class="row d-flex" *ngIf="showDataTable">
                          <div class="form-group col-md-4">
                          </div>
                          <div class="form-group col-md-6">
                              
                          </div>
                          <div class="form-group col-md-2 d-flex">
                                <button type="button" class="btn btn-primary" (click)="addRow()"><i class="feather icon-plus-circle"></i> Add Row</button>
                                <button type="button" class="btn btn-secondary" id="cancelButton" (click)="clearButton()">Clear</button>
                              
                          </div>  
                    </div>
                    <div class="row d-flex" *ngIf="showDataTable">
                      <div class="row mb-0" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                            [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="finalCommissionData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                      </div>

                    </div>
                    <br>
                    <div class="row d-flex">
                      <div class="form-group col-md-9"></div>
                      <div class="form-group col-md-3">
                        <button type="button" class="btn btn-secondary" id="cancelButton" (click)="switchTab('service')">Back</button>
                        <button type="button" class="btn btn-primary" (click)="saveCommissionSlab()" *ngIf="showDataTable" >Save</button>
                        <button type="button" class="btn btn-danger" id="cancelButton" (click)="cancelButton()">Cancel</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div> 
         </div>
    </div>  
</div>